// extracted by mini-css-extract-plugin
export default {"tagIcon":"Tag_tagIcon__jWy6u","container":"Tag_container__nyk2K","smallContainer":"Tag_smallContainer__ww7+N"};